import { PER_PAGE_VALUES } from "@utils/index";
import { Dropdown } from "@components/index";

export const PerPage = ({
  perPage,
  onSelect,
}: {
  perPage: string;
  onSelect: (page: string) => void;
}) => (
  <div className="flex items-center gap-x-1 md:gap-x-4">
    <div className="ml-4 text-300 text-black-54">Show:</div>
    <div className="w-40">
      <Dropdown
        items={PER_PAGE_VALUES.map((value) => ({
          id: value,
          title: `${value} per page`,
        }))}
        height="small"
        expandToTop
        value={perPage}
        onSelect={onSelect}
      />
    </div>
  </div>
);
